import {useCallback, useState} from 'react'

const usePop = (defaultData = {}, defaultProps = {}) => {
  const [show, setShow] = useState({open: false, data: {}})

  const pop = useCallback(
    (data, props) => {
      setShow({
        ...defaultProps,
        ...props,
        data: {defaultData, ...data},
        open: true,
      })
    }, // eslint-disable-next-line
    [setShow]
  )
  const close = useCallback(() => {
    setShow(p => ({...p, open: false}))
  }, [setShow])

  return {
    pop,
    close,
    props: show,
  }
}

export default usePop
